<template>
<v-select outlined single-line hide-details prepend-inner-icon="mdi-translate" v-model="currentLocale" :items="items"></v-select>
</template>

<script>
export default {
  name: 'LanguageMenu',
  computed: {
    currentLocale: {
      get() {
        return this.$i18n.locale;
      },
      set(val) {
        this.$i18n.locale = val;
        this.$cookie.set('lang', val);
      }
    },
    items() {
      return Object.keys(this.$i18n.messages).map(key => ({
        text: this.$t(`lang.${key}`),
        value: key
      }));
    }
  }
}
</script>
